import NodeEnvs from '~/config/NodeEnvs';

export const isProd = (): boolean => import.meta.env.VITE_NODE_ENV === NodeEnvs.PROD;

export const isE2ETest = (): boolean => import.meta.env.MODE === 'e2e';

export const isJenkinsTest = (): boolean => import.meta.env.MODE === 'jenkins';

export const isViTest = (): boolean => import.meta.env.MODE === 'test';

export const isNonProd = (): boolean => import.meta.env.VITE_NODE_ENV !== NodeEnvs.PROD;

export function getEnvironmentEnv(): typeof NodeEnvs[keyof typeof NodeEnvs] {
  if (import.meta.env.VITE_NODE_ENV === 'local') {
    return NodeEnvs.LOCAL;
  }

  if (import.meta.env.VITE_NODE_ENV === 'dev') {
    return NodeEnvs.DEV;
  }

  return NodeEnvs.PROD;
}

export const isClient = (): boolean => typeof window !== 'undefined';

export const isViteServer = (): boolean => import.meta.env.VITE_SERVER === 'true';

export const isServer = (): boolean => import.meta.env.VITE_SERVER === 'true' && typeof window === 'undefined';

export const isCSRMode = (): boolean => import.meta.env.VITE_SERVER !== 'true' && isClient();

export const isSSRHydration = (): boolean => import.meta.env.VITE_SERVER === 'true' && isClient();

export const isSentryEnabled = (): boolean => import.meta.env.VITE_ENABLE_SENTRY === 'true';

export const isCustomLoggingEnabled = (): boolean => import.meta.env.VITE_ENABLE_CUSTOM_LOGGING === 'true';

export const isPseudolocalizationEnabled = (): boolean => import.meta.env.MODE !== 'e2e' && import.meta.env.VITE_ENFORCE_PSEUDOLOCALIZE === 'true';

export const GOOGLE_API_KEY = import.meta.env.VITE_GOOGLE_API_KEY;
